import { useSelector } from 'react-redux';
import { useLDClient } from 'launchdarkly-react-client-sdk';

const useLDUser = () => {
  const ldClient = useLDClient();
  const context = ldClient.getContext();

  const isLdUserIdentified = useSelector(
    state => state.appState.isLdUserIdentified,
  );

  return { context, isLdUserIdentified };
};

export default useLDUser;
